/*
 * @Descripttion: 
 * @Author: dengyao
 * @Date: 2024-05-31 13:43:44
 * @LastEditors: hongye
 * @LastEditTime: 2025-05-30 18:30:41
 */
import request from '@/service/request'
enum Api {
  GET_EXPRESS_COMPANY_LIST = '/express/listExpress'
}

export default class commonService {
  /**
   * 获取快递公司列表
   * @param data
   * @returns
   */
  static getExpressCompanyList(data: any): Promise<any> {
    return request.post(Api.GET_EXPRESS_COMPANY_LIST, data)
  }
  /**
   * 获取数据字典
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post('/dict-value/getDictValue', data)
  }

  /**
   * 获取数据字典
   * @param data
   * @returns
   */
  static getAreaAddressList(): Promise<any> {
    return request.post('/address/versionUpdate')
  }

   /**
   * 获取地址库数据
   * @param data
   * @returns
   */
   static getAddressJson(url:string): Promise<any> {
    return request.get(url)
  }
  /**
   * 打印配置 打印面单是使用新面单还是老面单， true:新面单 false：老面单
   * @returns
   * */
  static printOrderConfig(): Promise<any> {
    return request.get('/orderParcel/printOrderConfig')
  }
}
